import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Invoice } from '.';
import * as fromInvoice from './invoice.reducer';

export const selectInvoiceState = createFeatureSelector<fromInvoice.State>(
    fromInvoice.invoicesFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromInvoice.adapter.getSelectors(selectInvoiceState);

export const selectActiveContracts = createSelector(
    selectInvoiceState,
    (state: fromInvoice.State) => state.ActiveContracts
);

// props, deprectated
export const selectInvoicesByContractId = createSelector(
    selectAll,
    (invoices: Invoice[], props) =>
        invoices.filter(x => props.ids.find(y => x.ContractListID === y))
);

//example: factory selector: https://github.com/ngrx/platform/issues/2980
export const selectInvoicesByContractId2 = (ids: string[]) =>
    createSelector(selectAll, invoices =>
        invoices.filter(x => ids.find(y => x.ContractListID === y))
    );
